import { Component, OnInit, inject } from '@angular/core';
import { Observable, finalize, takeUntil, tap } from 'rxjs';

import {
  CustomResultOfPaginatedListOfSocialMediaMessageFilesWithPaginationDto,
  GetEnumValuesDto,
  PaginatedListOfSocialMediaMessageFilesWithPaginationDto,
  SocialMediaFileStatus,
  SocialMediaMessageFilesWithPaginationDto,
} from 'src/app/core/api/models';
import { SocialNetworkMessageFilesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';
import { MediasFormComponent } from './medias-form/medias-form.component';
import { ShowMediaComponent } from './show-medias/show-medias.component';
import { UpdateStatusMediaComponent } from './update-status-medias/update-status-medias.component';
import { MenuBtnComponent } from 'src/app/shared/global/menu-btn/menu-btn.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';


@Component({
    selector: 'app-medias',
    templateUrl: './medias.component.html',
    imports: [
        BaseIndexModule,
        MenuBtnComponent,
    ]
})
export class MediasComponent extends BaseIndexPageComponent implements OnInit {
  //#region Properties
  pageName = 'medias';

   // binding component CRUD endpoints
  protected currentService = inject(SocialNetworkMessageFilesService);
  paginationApiMethodName: string = this.currentService.socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination.name;
  createGetApiMethodName: string = this.currentService.socialNetworkMessageFilesCreateGet.name;
  auditApiMethodName: string = this.currentService.socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination.name;
  // binding component CRUD endpoints

  modelWithPagination$: Observable<PaginatedListOfSocialMediaMessageFilesWithPaginationDto>;
  items$: Observable<Array<SocialMediaMessageFilesWithPaginationDto>>;

  SocialMediaFileStatusEnumValues: GetEnumValuesDto[] = [];
  SocialMediaFileTypesEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getEnumsValues() {
    this.getEnumValuesApi('SocialMediaFileStatus').subscribe(
      (values) => (this.SocialMediaFileStatusEnumValues = values)
    );
    this.getEnumValuesApi('SocialMediaFileTypes').subscribe(
      (values) => (this.SocialMediaFileTypesEnumValues = values)
    );
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: this.localizer.title,
        name: 'title',
        hasSearch: true,
        type: 'text',
      },
      {
        title: `${this.tableVocabs}fileSizePerKilobyte`,
        name: 'fileSizePerKilobyte',
        type: 'number',
        hasSearch: true,
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: this.localizer.status,
        name: 'status',
        hasSearch: true,
        type: 'enum',
        enumName: 'SocialMediaFileStatus',
      },
      {
        title: `${this.tableVocabs}fileTypes`,
        name: 'fileTypes',
        hasSearch: true,
        type: 'enum',
        enumName: 'SocialMediaFileTypes',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
      // {
      //   title: `${this.tableVocabs}url`,
      //   name: 'url',
      //   hasSearch: false,
      //   noSorting: true,
      //   type: 'text',
      // },
    ];
  }

  //#region api

  openCreateFormModal() {
    try {
      this.unSubs();

      const modalResult = this.dialogService.openModal({
        component: MediasFormComponent,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.pageConfig.isVisibleForm = undefined)),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.medias);
    }
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .socialNetworkMessageFilesDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion

  onEditStatus(id: number, status: SocialMediaFileStatus) {
    this.openEditStatusDialog(id, status);
  }

  openEditStatusDialog(id, status: SocialMediaFileStatus) {
    this.unSubs();
    let data: any = {
      id: id,
      status: status,
    };
    const modalResult = this.dialogService.openModal({
      component: UpdateStatusMediaComponent,
      data: data,
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res) {
          this.getTableData();
          this.cd.detectChanges();
        }
      });
  }

  onShowFiles(id, fileTypes) {
    try {
      this.unSubs();

      const modalResult = this.dialogService.openModal({
        component: ShowMediaComponent,
        data: { mediaId: id, fileTypes: fileTypes },
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.medias);
    }
  }
}
